const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Riya Joshi</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Social Media Head, UPES-CSI</li>
    <li>
        Managing CSI's social media presence.
    </li>
    <li>
        Creating engaging content for online platforms.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
